import $ from "jquery"
import updateH1 from "./listing/updateH1"
import updateLangLinks from "./listing/updateLangLinks"
import createBreadcrumbs from "./listing/createBreadcrumbs"

const collections = () => {
  const ajaxCollection = () => {
    const collectionHolder = document.querySelector(".collections")
    const linksHolder = document.querySelector(".news-categories")

    const updateCollectionCategories = (currentCategoryUrl) => {
      const collectionCategoryList = linksHolder.querySelectorAll("li")
      collectionCategoryList.forEach((category) => {
        const categoryUrl = category.querySelector("a")?.href
        category.classList.toggle("active", categoryUrl === currentCategoryUrl)
      })
    }

    const getCollectionItemLayout = ({ url, image, name }) =>
      `<div class="collections__item">
          <a href="${url}" class="collections__link">
              <img class="collections__img" src="${image}" alt="" />
              <div class="collections__name">${name}</div>
          </a>
      </div>`

    const updateCollectionsLayout = (collectionsList) => {
      const collectionItems = collectionsList.map(getCollectionItemLayout).join("")
      collectionHolder.innerHTML = collectionItems
    }

    const updateWindowUrl = (url) => {
      window.history.pushState("", "", url)
    }

    const makeRequest = (collectionId) => {
      const locale = document.documentElement.getAttribute("lang")
      const baseUrl = `${locale === "ru" ? "" : `/${locale}`}/api/collections/`
      const url = baseUrl + (collectionId ? `type/${collectionId}` : "")

      $.ajax({
        url,
        type: "get",
        dataType: "json",
        beforeSend: () => {
          //   preloader(true);
        },
        success: (success) => {
          const newUrl =
            document.location.origin +
            Object.entries(success.url_by_locale).find(([k]) => k === locale)[1]
          updateCollectionCategories(newUrl)
          updateCollectionsLayout(success.list)
          updateH1({ h1: success.h1 })
          updateWindowUrl(newUrl)
          createBreadcrumbs(success.breadcrumbs)
          updateLangLinks(success.url_by_locale)
        },
        complete: () => {
          //   preloader(false);
        },
      })
    }

    linksHolder.addEventListener("click", (e) => {
      if (e.target.tagName === "A") {
        e.preventDefault()
        const collectionId = e.target.href.split("collections/").pop().replaceAll("/", "")
        makeRequest(collectionId)
      }
    })
  }

  ajaxCollection()
}
export default collections
